import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { OffCanvas, Anchor, Icons, Divider } from '@mirohq-internal/website-ui-foundation';

const Drawer = ({ backdropClassName, children, className, handleBack, currentMenuPath, handleClose, show, title, offCanvasProps })=>{
    return jsxs(OffCanvas, {
        className: classNames('border-0', className),
        backdropClassName: backdropClassName,
        show: show,
        handleClose: handleClose,
        ...offCanvasProps,
        children: [
            jsxs(OffCanvas.Header, {
                className: "px-300 gap-150",
                children: [
                    jsxs("div", {
                        className: "d-flex align-items-center gap-150",
                        children: [
                            !!currentMenuPath?.length && jsx(Anchor, {
                                size: "md",
                                circularBg: true,
                                withHoverBg: true,
                                onClick: handleBack,
                                "aria-label": "Back to Main menu",
                                children: jsx(Icons.ChevronLeft, {
                                    size: "md"
                                })
                            }),
                            jsx(OffCanvas.Title, {
                                children: title
                            })
                        ]
                    }),
                    jsx(Anchor, {
                        size: "md",
                        circularBg: true,
                        withHoverBg: true,
                        onClick: handleClose,
                        "aria-label": "Close Menu",
                        children: jsx(Icons.Cross, {
                            size: "md"
                        })
                    })
                ]
            }),
            jsx(Divider, {
                light: true
            }),
            jsx(OffCanvas.Body, {
                className: "py-400 px-300",
                children: children
            })
        ]
    });
};

export { Drawer };
